export function fmtMoney(n) {
  const num = Number(n || 0);
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Currency symbol map — keep small; falls back to trailing code for unknowns.
const CURRENCY_SYMBOLS = {
  USD: "$", IDR: "Rp", EUR: "€", AUD: "A$",
  SGD: "S$", GBP: "£", JPY: "¥", CNY: "¥",
};

// Money with symbol prefix (e.g. "$1,234.00"). Falls back to
// "1,234.00 XYZ" when the currency has no known symbol.
export function fmtPrice(n, currency = "USD") {
  const cur = String(currency || "USD").toUpperCase();
  const sym = CURRENCY_SYMBOLS[cur];
  const num = Number(n || 0);
  const formatted = num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return sym ? `${sym}${formatted}` : `${formatted} ${cur}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleString(undefined, {
      year: "numeric", month: "short", day: "2-digit",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
